import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=7095993f&scoped=true"
import script from "./informationDetail.vue?vue&type=script&lang=ts"
export * from "./informationDetail.vue?vue&type=script&lang=ts"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=7095993f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7095993f",
  null
  
)

export default component.exports